import React, { FunctionComponent, useEffect, useState } from "react";
import { Select, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import "./form-item-dropdown.scss";
import {
  IDataOptions,
  IDataSelect,
  IDataSelectStatus,
} from "../../types/listUsers";

type FormItemDropdownProps = {
  modeDropdown?: "multiple" | "tags";
  disabled?: boolean;
  allowClear?: boolean;
  loading?: boolean;
  placeholder?: string;
  style?: any;
  disabledOptions?: boolean;
  options?: IDataSelect[] | IDataOptions[] | IDataSelectStatus[] | unknown[];
  defaultValue?: string | string[] | number | number[];
  onChange?: (values: any) => void;
  onPopupScroll?: (e: any) => void;
  value?: any;
  optionValue?: any;
  className?: string;
  priority?: string;
  onBlur?: (values: any) => void;
  description?: boolean;
  disabledReason?: string;
};

const FormItemDropdown: FunctionComponent<FormItemDropdownProps> = ({
  modeDropdown,
  options,
  placeholder,
  disabled,
  disabledReason = "Vui lòng chọn trường trước",
  allowClear,
  value,
  className,
  defaultValue,
  priority,
  onChange,
  onPopupScroll,
  onBlur,
  style,
  loading,
  description,
}) => {
  const { t } = useTranslation();
  const translatedPlaceholder = typeof placeholder === "string" ? t(placeholder, placeholder) : placeholder;
  const [optionsStateFilter, setOptionsStateFilter] = useState<any[]>([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (options) {
      setOptionsStateFilter(options);
    }
  }, [options]);

  const handleSearch = (searchValue: string) => {
    setSearchText(searchValue);
    if (!options) return;
    const filtered = (options as any[]).filter((opt) => {
      const label =
        opt.nameEn ||
        opt.name ||
        opt.label ||
        opt.ten ||
        opt.email ||
        opt.assignUserName ||
        opt.enterpriseName;
      return label?.toLowerCase().includes(searchValue.toLowerCase());
    });
    setOptionsStateFilter(filtered);
  };

  const dropdown = (
    <Select
      onChange={onChange}
      onBlur={onBlur}
      showSearch
      onSearch={handleSearch}
      filterOption={false}
      style={style}
      disabled={disabled}
      optionFilterProp="children"
      maxTagCount="responsive"
      allowClear={allowClear}
      value={value}
      placeholder={translatedPlaceholder}
      mode={modeDropdown}
      onPopupScroll={onPopupScroll}
      virtual={false}
      loading={loading}
      defaultValue={defaultValue}
      notFoundContent={
        <span style={{ textAlign: "center" }}>
          <p>
            <img
              className="image-empty-data"
              src="/images/empty-img-gray.png"
              alt="empty-img"
            />
          </p>
          <p className="nodata-text">{t("Không tìm thấy", "Không tìm thấy")}</p>
        </span>
      }
      className={className}
      optionLabelProp="label"
    >
      {optionsStateFilter?.map((option: any, index: number) => (
        <Select.Option
          key={option.value || option.code || option.id || index}
          disabled={option.disabled ?? false}
          value={
            typeof option.value === "boolean"
              ? option.value
              : priority
                ? option.code
                : option.id ||
                option.assignUserId ||
                option.enterpriseId ||
                option.code
          }
          label={
            (() => {
              const raw = option.nameEn || option.name || option.label || option.ten || option.email || option.assignUserName || option.enterpriseName;
              return typeof raw === "string" ? t(raw, raw) : raw;
            })()
          }
        >
          <div>
            <div>
              {(() => {
                const raw = option.nameEn || option.name || option.label || option.ten || option.email || option.assignUserName || option.enterpriseName;
                return typeof raw === "string" ? t(raw, raw) : raw;
              })()}
            </div>
            {description && option.description && (
              <div
                style={{
                  fontSize: "12px",
                  color: "#757575",
                  fontStyle: "italic",
                  fontWeight: "normal",
                }}
              >
                {option.description}
              </div>
            )}
          </div>
        </Select.Option>
      ))}
    </Select>
  );

  return disabled ? (
    <Tooltip title={disabledReason} placement="topLeft">
      <div style={{ pointerEvents: "none" }}>{dropdown}</div>
    </Tooltip>
  ) : (
    dropdown
  );
};

export default FormItemDropdown;
